module.exports = __webpack_public_path__ + "img/googlePlay.292203da.png";